import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { hasPermission } from '@/hooks/useBackendMenu'
import { CompensacaoManual } from '@/service/api/endpoints/compensacao-manual'
import { ButtonGroup, IconButton } from '@mui/material'
import { PencilIcon, Trash2Icon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function OpcoesCompensacaoManualButton({
    row,
}: GridCellParams<CompensacaoManual>) {
    const navigate = useNavigate()

    return (
        <ButtonGroup size="small" variant="outlined">
            {hasPermission(['update', 'CompensaçãoManual'], () => (
                <IconButton
                    onClick={() =>
                        navigate(
                            `/manutencao-ponto/compensacao-manual/${row.id}/editar`,
                        )
                    }
                    title="Editar"
                >
                    <PencilIcon className="size-5" />
                </IconButton>
            ))}
            {hasPermission(['delete', 'CompensaçãoManual'], () => (
                <IconButton
                    onClick={() =>
                        navigate(
                            `/manutencao-ponto/compensacao-manual/${row.id}/excluir`,
                        )
                    }
                    title="Excluir"
                >
                    <Trash2Icon className="size-5 text-error" />
                </IconButton>
            ))}
        </ButtonGroup>
    )
}
